import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const TransitionsDashboardPageMeetingTranscriptsPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.transitionsDashboardPageAdvice.name]: (
      <MetaControlField attr={'transitionsDashboardPageMeetingTranscripts'} />
    ),
  }, null);
};

TransitionsDashboardPageMeetingTranscriptsPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
TransitionsDashboardPageMeetingTranscriptsPicker.defaultProps = {};

export default TransitionsDashboardPageMeetingTranscriptsPicker;
